import classNames from "classnames";
import styles from "./AscParagraph.module.scss";
import React from "react";

export interface AscParagraphProps
  extends React.HTMLAttributes<HTMLParagraphElement> {
  children?: React.ReactNode;
  showFull?: boolean;
  setShowFull?: (showFull: boolean) => void;
  excerptLength?: number;
  seeMoreText?: string;
  seeLessText?: string;
  className?: string;
  loading?: boolean;
}

export default function AscParagraph({
  children,
  showFull = undefined,
  setShowFull = undefined,
  excerptLength = 100,
  seeMoreText = " See more",
  seeLessText = " See less",
  className,
  loading = false,
  ...props
}: AscParagraphProps) {
  if (typeof children !== "string" || showFull === undefined) {
    return (
      <p
        className={classNames(
          styles.ground,
          {
            [styles.loading]: loading,
          },
          className
        )}
        {...props}
      >
        {children}
      </p>
    );
  }

  const excerpt = children?.slice(0, excerptLength);
  const hasMore = children?.length > excerptLength;

  return (
    <p
      className={classNames(
        styles.ground,
        {
          [styles.loading]: loading,
        },
        className
      )}
      {...props}
    >
      {showFull ? children : excerpt}
      {hasMore && !showFull && !setShowFull ? "..." : ""}
      {hasMore && !showFull && setShowFull && (
        <span className={styles.seeMore} onClick={() => setShowFull(true)}>
          {seeMoreText}
        </span>
      )}
      {hasMore && showFull && setShowFull && (
        <span className={styles.seeMore} onClick={() => setShowFull(false)}>
          {seeLessText}
        </span>
      )}
    </p>
  );
}
